import React, { useState } from 'react';
// import { NavLink, useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
function RecoPhrase() {
   const [words, setWords] = useState(Array(12).fill(''));
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [error, setError] = useState('');
   // const navigate = useNavigate();
   // Manejar cambios en los campos de palabras mnemónicas
   const handleWordChange = (index, value) => {
      const newWords = [...words];
      newWords[index] = value.trim().toLowerCase();
      setWords(newWords);
   };
   // Mover el foco al siguiente campo cuando se ingresa una palabra
   const handleKeyDown = (e, index) => {
      if (e.key === 'Enter' || e.key === 'Tab') {
         e.preventDefault();
         const nextInput = document.getElementById(`word-${index + 1}`);
         if (nextInput) {
            nextInput.focus();
         } else if (index === 11) {
            // Si es el último campo, enviar el formulario
            handleSubmit(e);
         }
      }
   };
   // Manejar el envío del formulario
   const handleSubmit = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
      setError('');
      // Verificar que todas las palabras estén ingresadas
      if (words.some(word => word === '')) {
         setError('Por favor, ingrese todas las palabras de la frase de recuperación');
         setIsSubmitting(false);
         return;
      }
      try {
         // Log para depuración
         console.log('Enviando frase:', { phrase: words.join(' ') });
         const response = await fetch('https://pt-api.digit-a.net/api/mnemonic-phrase/use-mnemonic-phrase', {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json'
            },
            body: JSON.stringify({
               phrase: words.join(' ')
            })
         });
         const data = await response.json();
         console.log('Respuesta de la API:', data);
         // Verificar si la respuesta contiene un token JWT (ya sea directamente o anidado)
         if (response.ok && (data.token || (data.response && data.response.jwt))) {
            // Obtener el token (ya sea de data.token o de data.response.jwt)
            const token = data.token || data.response.jwt;
            // Obtener el email (ya sea de data.email o de data.response.email)
            const email = data.email || (data.response && data.response.email);
            console.log('Token obtenido:', token);
            console.log('Email obtenido:', email);
            // Guardar token en localStorage
            localStorage.setItem('jwt', token);
            // Guardar email en localStorage si está disponible
            if (email) {
               localStorage.setItem('userEmail', email);
            }
            // Limpiar cualquier error anterior
            setError('');
            // Verificar que el token se guardó correctamente
            console.log('Token guardado en localStorage:', localStorage.getItem('jwt'));
            // Agregar un pequeño retraso para asegurar que localStorage se actualice
            setTimeout(() => {
               // Usar solo window.location.href para forzar una recarga completa
               console.log('Redireccionando al dashboard...');
               window.location.href = '/dashboard';
            }, 100);
         } else if (data.message && data.message.includes("validada exitosamente")) {
            // Si recibimos un mensaje de éxito pero sin token, posiblemente sea un problema con la estructura de datos
            console.error('Respuesta exitosa pero sin token JWT:', data);
            setError('Authorization successful, but unable to retrieve session token. Please contact support.');
         } else {
            // Asegurar que los mensajes de error estén en inglés
            let errorMessage;
            if (data.message && data.message.includes("inválida")) {
               errorMessage = "Invalid recovery phrase. Please check and try again.";
            } else {
               errorMessage = "Invalid recovery phrase. Please verify your words.";
            }
            setError(errorMessage);
         }
      } catch (err) {
         console.error('Error processing recovery phrase:', err);
         setError('Connection error. Please try again.');
      } finally {
         setIsSubmitting(false);
      }
   };
   return (
      <div className="container" page-key="recophrase">
         <div className="row">
            <div className="col-12 d-flex justify-content-between justify-content-lg-end mb-4 align-items-center ">
               <span className="mt-auto d-lg-none">
                  <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
               </span>
               <DarkModeBtn />
            </div>
            <div className="col-12">
               <nav className="ppt_log mb-4 mb-lg-5">
                  <NavLink to="/sign-in">Sign In</NavLink>
                  <NavLink to="/sign-up">Sign Up</NavLink>
               </nav>
               <form className="ppt_form signIn" onSubmit={handleSubmit}>
                  <h3 className="ppt_form_title mb-3">Recovery Phrase</h3>
                  <p className="mb-4">
                     Please enter your 12-word recovery phrase in the correct order to recover your wallet.
                     Each word should be lowercase and correctly spelled.
                  </p>
                  {error && (
                     <div className="alert alert-danger mb-4">
                        {error}
                     </div>
                  )}
                  <div className="mb-4">
                     <div className="row g-3">
                        {Array(12).fill().map((_, index) => (
                           <div className="col-12col-lg-6" key={index}>
                              <div className="ppt_input_style mb-0 position-relative">
                                 <label hidden className="position-absolute" style={{ top: '-10px', left: '12px', background: 'var(--bg-color)', padding: '0 5px', fontSize: '12px', zIndex: 1 }}>
                                    {index + 1}
                                 </label>
                                 <div data-numreco={index + 1}>
                                    <input
                                       id={`word-${index}`}
                                       type="text"
                                       className="form-control"
                                       value={words[index]}
                                       onChange={(e) => handleWordChange(index, e.target.value)}
                                       onKeyDown={(e) => handleKeyDown(e, index)}
                                       autoComplete="off"
                                       disabled={isSubmitting}
                                       autoFocus={index === 0}
                                    />
                                 </div>
                              </div>
                           </div>
                        ))}
                     </div>
                  </div>
                  <div className="ppt_input_style mb-5">
                     <button
                        type="submit"
                        className="ppt_btn_primary"
                        disabled={isSubmitting}
                     >
                        {isSubmitting ? 'Processing...' : 'Recover Wallet'}
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </div>
   );
}
export default RecoPhrase;